
/* ----- dhl packstation -------------------------------------------------------------------------------------------- */

$(function(){

	if ( ($('html#shop-address-combined').length || $('html#shop-deliv-address-manage').length) && ( ( typeof(euramin_shop_language)!=='undefined' && euramin_shop_language==='DEU' ) || $('html.shop-testmode').length ) ) { // && (typeof(euramin_testmode)!=='undefined') && euramin_testmode

		var form_input_error_class = 'form-control-error';

		// additional stuff to do on combined address template

		// check selected address on load and on ajax reload
		// and remove non-DEU countries when DHL Packstation is selected
		var removeAllDeliveryAddressCountriesExceptDEU;
		(removeAllDeliveryAddressCountriesExceptDEU = function () {
			var deu_country_str = 'Deutschland,DEU', // <-- TODO: Hier die korrekte Bezeichnung f�r Deutschland eintragen!
				delivery_address_type = $('input[name="ws_input_delivery_suffix4"]:checked').val(); // 01 = Postalische Lieferadresse | 02 = DHL Packstation
			if (typeof(delivery_address_type)!=='undefined' && delivery_address_type==='02') {
				$('#ws_input_delivery_country option[value!="' + deu_country_str + '"]').remove();
				$('#ws_input_delivery_country option').not(':first').remove();
			}
		})();
		$(document).ajaxComplete(removeAllDeliveryAddressCountriesExceptDEU);



		// enhance Packstation Nr field
		var enhancePackstationNrField;
		(enhancePackstationNrField = function () {
			var delivery_address_type = $('input[name="ws_input_delivery_suffix4"]:checked').val(); // 01 = Postalische Lieferadresse | 02 = DHL Packstation
			if (typeof(delivery_address_type)!=='undefined' && delivery_address_type==='02') {
				var delivery_address = $('.form-fields-group.delivery_address'),
					delivery_postnr_field = delivery_address.find('input.input_company'), // changed from suffix1 to company
					delivery_postnr,
					delivery_packstation_nr_field = delivery_address.find('input.input_street1'),
					delivery_packstation_nr_field_wrapper,
					delivery_packstation_nr = $.trim(delivery_packstation_nr_field.val()),
					form = delivery_address.closest('form'),
					str_packstation = 'Packstation',
					str_postfiliale = 'Postfiliale',
					_;

				// create select field and modify form
				var delivery_packstation_type_select_field = $('<select class="form-control select_delivery_packstation_type"><option value="00"></option><option value="01">' + str_packstation + '</option><option value="02">' + str_postfiliale + '</option></select>');

				delivery_packstation_type_select_field = delivery_packstation_type_select_field.wrapAll('<div class="col-sm-4 col-md-5"><div class="form-group form-group-select"><div class="form-item"><span class="plain-select"></span></div></div></div>').parent().parent().parent().parent();
				delivery_packstation_nr_field_wrapper = delivery_packstation_nr_field.addClass('input_delivery_packstation_number').wrapAll('<div class="col-sm-8 col-md-7"><div class="form-group form-group-input"><div class="form-item"></div></div></div>').parent().parent().parent();
				delivery_packstation_nr_field_wrapper.before(delivery_packstation_type_select_field);

				// var group = $(delivery_packstation_type_select_field).add(delivery_packstation_nr_field).wrapAll('<div class="form-control-group row"></div>').parent();
				var group = $(delivery_packstation_type_select_field).add(delivery_packstation_nr_field_wrapper);
				group.unwrap();
				var form_control_group = group.parent().removeClass('form-group form-group-input').addClass('form-control-group row');
				// form_control_group.unwrap();
				form_control_group.find('.shop-form-field-errormessage').wrapAll('<div class="col-xxs-12"></div>');
				form_control_group.find('.control-label').addClass('shop-form-label-across').removeClass('above');

				// extract packstation type from delivery packstation number field and update select field
				if (delivery_packstation_nr.indexOf(str_packstation)===0) {
					delivery_packstation_type_select_field.find('option[value="01"]').prop('selected', true);
				} else if (delivery_packstation_nr.indexOf(str_postfiliale)===0) {
					delivery_packstation_type_select_field.find('option[value="02"]').prop('selected', true);
				} else {
					delivery_packstation_type_select_field.find('option[value="00"]').prop('selected', true);
					// check if form already displays input errors and mark selectbox accordingly
					if (delivery_packstation_nr_field.hasClass(form_input_error_class)) {
						delivery_packstation_type_select_field.closest('.form-control-group').addClass(form_input_error_class);
					}
				}

				// remove chars ('Packstation'|'Postfiliale' from field value)
				delivery_packstation_nr_field.val(delivery_packstation_nr.replace(/[^0-9]/g, ''));
				// todo: besser nur "Packstation" und "Postfiliale" l�schen. Effekt derzeit ist, dass bei mehrfachem Submit auf einmal unerlaubte Zeichen verschwinden.
				// das Verhalten ist aber nicht nachvollziehbar f�r den Benutzer, weil ja zun�chst eine Fehlermeldung erscheint, die dann wieder verschwindet


				var pad = function (str, max) {
					str = str.toString();
					return str.length < max ? pad('0' + str, max) : str;
				};
				// re-insert packstation type string into delivery packstation number field, which is street1
				form.submit(function(){

					var pattern_numbers_only = /^[0-9]+$/;
					delivery_postnr = delivery_postnr_field.val().replace(/\s/g, ''); // remove whitespace
					if (pattern_numbers_only.test(delivery_postnr)) {
						delivery_postnr_field.val(pad(delivery_postnr, 10));
					} // else: see shop configuration -> error will be checked on the server side
					// prepare packstation nr field value: prepend string "Packstation" / "Postfiliale"
					delivery_packstation_nr_field.addClass('shop-form-input-invisible').val(delivery_packstation_type_select_field.find('option:selected').text() + ' ' + delivery_packstation_nr_field.val());

					// set custom event handler, which will be triggered, if the form submit is cancelled
					form.on('customEventOnFormSubmitCancelled', function(){
						// when form submit was cancelled, remove chars/string from packstation nr field (only number remains)
						delivery_packstation_nr_field.val( delivery_packstation_nr_field.val().replace(/[^0-9]/g, '') ).removeClass('form_input_invisible');
					});

				});
			}
		})();
		$(document).ajaxComplete(enhancePackstationNrField);

	}

});

/* ------------------------------------------------------------------------------------------------------------------ */

